import { Plus } from 'lucide-react';

import {
  BADGE_VALIDITY_MONTHS,
  REPORT_TURNAROUND_LABEL,
} from '@repo/contracts/services-pricing';

import { Container, SectionHeading } from '../ui';

const FAQ = [
  {
    a: 'No. Tooling finds candidates fast. A specialist verifies every finding, removes false positives, assesses what tools can’t judge, and writes the fix guidance.',
    q: 'Is this just an automated scan?',
  },
  {
    a: 'No. It’s an expert audit against WCAG with a dated, verifiable record of who audited your site and when. It shows where you stand and what to fix.',
    q: 'Is this a compliance certification?',
  },
  {
    a: 'Our tooling does the exhaustive legwork — every page, control and state. Specialists spend their time on judgement: verifying findings and assessing what tools can’t. You pay for expertise, not hours of clicking.',
    q: 'Why is it so much cheaper than a manual audit?',
  },
  {
    a: 'Yes, for websites and web apps. EN 301 549 clause 9 is WCAG 2.1 AA, and we cite each finding by both. Native mobile and desktop apps aren’t supported yet.',
    q: 'Does this cover EN 301 549 and the European Accessibility Act?',
  },
  {
    a: `Nothing up front. After scoping we send a teaser and an invoice. The full report usually follows within ${REPORT_TURNAROUND_LABEL} of payment; larger scopes can take longer.`,
    q: 'When do I pay?',
  },
  {
    a: 'One distinct template or screen state, such as your home page, a product template or a checkout step. We agree the list with you during scoping.',
    q: 'What counts as a page?',
  },
  {
    a: 'Yes. Documents and reports stay private, shared only by expiring links, and we’ll sign your NDA. For pages behind a login we agree a test account during scoping, never passwords in a form.',
    q: 'Is our site and data kept confidential?',
  },
  {
    a: `${BADGE_VALIDITY_MONTHS} months from the audit date. After that, its verification page shows it as expired.`,
    q: 'How long is the badge valid?',
  },
];

export function Faq() {
  return (
    <section aria-labelledby="faq-title" className="py-24 md:py-32" id="faq">
      <Container className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHeading
            eyebrow="FAQ"
            id="faq-title"
            title="Questions, answered"
          />
        </div>
        <div className="divide-y divide-hairline border-y border-hairline lg:col-span-8">
          {FAQ.map(({ a, q }) => (
            <details className="group py-2" key={q}>
              <summary className="flex cursor-pointer list-none items-center justify-between gap-6 rounded-button py-4 text-subtitle font-semibold text-text-primary [&::-webkit-details-marker]:hidden">
                <h3>{q}</h3>
                <Plus
                  aria-hidden
                  className="shrink-0 transition-transform duration-200 group-open:rotate-45"
                  size={20}
                />
              </summary>
              <p className="pb-5 pr-10 text-body text-text-secondary">{a}</p>
            </details>
          ))}
        </div>
      </Container>
    </section>
  );
}
